import React from "react";
import { ImageHelper } from "../../../../common/Helpers";
import "../../promotions/preview/PromotionPreview.scss";
import "./FilmFestivalPreview.scss";
import { ProgrammeCardPreview } from "./ProgrammeCardPreview";

export class FilmFestivalPreview extends React.Component {
  render() {
    const { festival, programmeInfo } = this.props;
    const posterUrl = ImageHelper.getPosterUrl(festival.poster);
    const programmes = programmeInfo || [];

    return (
      <div className="main-content promotions-detail-content film-festival-preview">
        <div className="container">
          <div className="handlebar-promotion-head">
            <div className="film-festival-preview__hero">
              <div className="content-wrap p-d row">
                <div className="col-md-4 col-xs-12 film-festival-preview__poster-col">
                  <div className="block-tablet hide-for-desktop display_none_ie7">
                    <h2
                      className="promo-title"
                      title={festival.name}
                    >
                      {festival.name}
                    </h2>
                  </div>
                  <div className="block-img">
                    <a
                      className="image-overlay-box cboxElement"
                      href={posterUrl}
                    >
                      <img
                        src={posterUrl}
                        alt={festival.name}
                        onError={ImageHelper.onPosterError}
                        className="img-responsive"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-md-8 col-xs-12">
                  <div className="block-tablet-desktop show-for-desktop-only">
                    <h2 title={festival.name}>{festival.name}</h2>
                  </div>
                  <div className="col-right">
                    <div className="block-info">
                      <div
                        className="description"
                        dangerouslySetInnerHTML={{
                          __html: festival.description,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h1 className="film-festival-preview__programme-heading">
                FILM FESTIVAL PROGRAMME
              </h1>
            </div>
            <div className="movie-lists film-festival-preview__programme">
              {programmes.length === 0 && (
                <p className="film-festival-preview__empty">
                  No movies are currently available. Please check back
                  again later.
                </p>
              )}
              {programmes.map((programme, index) => (
                <ProgrammeCardPreview programmes={programme} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
